module.exports = "https://bicocca-network.servercdn.it/static/img/arrow.svg?ee9fc4c71428bafa028e030335a84a4d";